import React from 'react';
import classNames from 'classnames';
import styles from './MultiStateSwitch.module.scss';

interface Props {
  name: string;
  checked?: boolean;
  trueLabel: string;
  falseLabel: string;
  onChange: (checked: boolean) => void;
}

const MultiStateSwitch = ({
  name,
  checked,
  trueLabel,
  falseLabel,
  onChange,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        <input
          id="no"
          type="radio"
          name={name}
          checked={checked !== undefined && !checked}
          onChange={() => onChange(false)}
          className={styles.input}
        />
        {falseLabel}
      </label>
      <div className={styles.bar}>
        <label htmlFor="no" className={styles.barLabel} />
        <div
          className={classNames(
            styles.indicator,
            checked === undefined
              ? ''
              : checked === false
              ? styles.unchecked
              : styles.checked,
          )}
        />
        <label htmlFor="yes" className={styles.barLabel} />
      </div>
      <label className={styles.label}>
        <input
          id="yes"
          type="radio"
          name={name}
          checked={checked}
          onChange={() => onChange(true)}
          className={styles.input}
        />
        {trueLabel}
      </label>
    </div>
  );
};

export default MultiStateSwitch;
